import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import { StudentNavbar, ModuleOverview, SubjectSideNavigation } from '../../../../../components';
import math from '../../../../../assets/math.webp';

const StatisticsAndProbability = () => {
  const subjectName = "Mathematics";
  const examType = "BGCSE";

  // Index should always equal the module_number
  const [selectedModule, setSelectedModule] = useState({
    index: 5,
    title: "Statistics and Probability",
  });

  const [showModuleMenu, setShowModuleMenu] = useState(false);

  const handleModuleSelect = (module) => {
    setSelectedModule(module);
    setShowModuleMenu(false);
  };

  return (
    <div>
      <StudentNavbar />

      <div className="bg-white w-full">
        <div className="grid grid-cols-1 lg:grid-cols-5">
          <div className="hidden lg:block lg:col-span-1 text-sm">
            <SubjectSideNavigation
              selectedModuleIndex={selectedModule.index}
              setSelectedModule={setSelectedModule}
              subjectName={subjectName}
              img={math}
            />
          </div>

          <div className="col-span-1 lg:col-span-4 bg-[#f0f0f0] min-h-screen px-3 sm:px-5 py-3 sm:py-5 lg:h-[calc(100vh-100px)] overflow-y-auto">
            <div className="lg:hidden mb-4">
              <button
                onClick={() => setShowModuleMenu(!showModuleMenu)}
                className="w-full bg-white rounded-lg shadow-sm px-4 py-3 flex items-center justify-between text-gray-700 hover:bg-gray-50 transition"
              >
                <div className="flex items-center gap-3">
                  <img
                    src={math}
                    alt={subjectName}
                    className="h-8 w-8 rounded object-cover"
                  />
                  <div className="flex flex-col items-start leading-tight">
                    <span className="font-semibold">{subjectName} Modules</span>
                    <span className="text-xs text-gray-500">
                      Currently: {selectedModule.title}
                    </span>
                  </div>
                </div>

                {showModuleMenu ? (
                  <RiCloseLine size={24} className="text-gray-600" />
                ) : (
                  <RiMenu3Line size={24} className="text-gray-600" />
                )}
              </button>

              {showModuleMenu && (
                <div className="mt-2 bg-white rounded-lg shadow-lg overflow-hidden animate-scale-down">
                  <SubjectSideNavigation
                    selectedModuleIndex={selectedModule.index}
                    setSelectedModule={handleModuleSelect}
                    subjectName={subjectName}
                    img={math}
                  />
                </div>
              )}
            </div>

            <ModuleOverview
              module_number={selectedModule.index}
              module_name={selectedModule.title}
              module_description={`
                This module develops your ability to collect, organize, interpret, and communicate
                data clearly. You’ll work with tables, charts, graphs, averages, and measures of
                spread, while learning how to draw conclusions from data in meaningful ways. You’ll
                also study probability to describe and calculate the likelihood of events, helping
                you make predictions and reason logically in uncertain situations.
              `}
              subject_name={subjectName}
              exam_type={examType}
            />
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scale-down {
          0% {
            transform: scaleY(0);
            opacity: 0;
            transform-origin: top;
          }
          100% {
            transform: scaleY(1);
            opacity: 1;
            transform-origin: top;
          }
        }
        .animate-scale-down {
          animation: scale-down 0.2s ease-out both;
        }
      `}</style>
    </div>
  );
};

export default StatisticsAndProbability;